var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsGraphGender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#C587CA",
    cx: 24,
    cy: 21.001,
    rx: 9,
    ry: 9.001
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8CB1D1",
    cx: 56,
    cy: 21.001,
    rx: 9,
    ry: 9.001
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.967 34h12.066a3.6 3.6 0 0 1 3.533 2.913l5.6 28.8A3.6 3.6 0 0 1 35.633 70H12.367a3.6 3.6 0 0 1-3.533-4.287l5.6-28.8A3.6 3.6 0 0 1 17.967 34z",
    fill: "#94339B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.967 70h12.066a3.6 3.6 0 0 0 3.533-2.913l5.6-28.8A3.6 3.6 0 0 0 67.633 34H44.367a3.6 3.6 0 0 0-3.533 4.287l5.6 28.8A3.6 3.6 0 0 0 49.967 70z",
    fill: "#3B709D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGraphGender);
export default __webpack_public_path__ + "static/media/icons_graph_gender.f5e32b5344fe7c570d067d80d2fc8db5.svg";
export { ForwardRef as ReactComponent };